import type { TPredikatKinerjaSubmissionStep } from 'types/kinerja-pelaksanaan'
import type {
  TPenetapanRatingPerilakuKerja,
  TPenetapanRatingPraktikKinerja,
} from 'types/kinerja-ks-pelaksanaan'

export const PENETAPAN_PREDIKAT_KINERJA_STEPS: Record<
  TPredikatKinerjaSubmissionStep,
  {
    order: number
  }
> = {
  NOT_CREATED: { order: 0 },
  SUBMIT_KADIS: { order: 1 },
  SUBMIT_GURU: { order: 2 },
  SUBMIT_BKN: { order: 3 },
}

export const PENETAPAN_PREDIKAT_KINERJA_RATINGS_PRAKTIK_KINERJA: TPenetapanRatingPraktikKinerja[] =
  ['Di Bawah Ekspektasi', 'Sesuai Ekspektasi', 'Di Atas Ekspektasi']

export const PENETAPAN_PREDIKAT_KINERJA_RATINGS_PERILAKU_KERJA: TPenetapanRatingPerilakuKerja[] =
  ['Di Bawah Ekspektasi', 'Sesuai Ekspektasi', 'Di Atas Ekspektasi']

export const PENETAPAN_PREDIKAT_KINERJA: Record<
  TPenetapanRatingPraktikKinerja,
  Record<TPenetapanRatingPerilakuKerja, string>
> = {
  'Di Atas Ekspektasi': {
    'Di Bawah Ekspektasi': 'Kurang',
    'Sesuai Ekspektasi': 'Baik',
    'Di Atas Ekspektasi': 'Sangat Baik',
  },
  'Sesuai Ekspektasi': {
    'Di Bawah Ekspektasi': 'Kurang',
    'Sesuai Ekspektasi': 'Baik',
    'Di Atas Ekspektasi': 'Baik',
  },
  'Di Bawah Ekspektasi': {
    'Di Bawah Ekspektasi': 'Sangat Kurang',
    'Sesuai Ekspektasi': 'Butuh Perbaikan',
    'Di Atas Ekspektasi': 'Butuh Perbaikan',
  },
}
